
import { Component, Prop, Vue } from 'vue-property-decorator';
import ExpansionPanel from '@/components/shared/ExpansionPanel.vue';
import TextMenu from '@/components/menu/TextMenu.vue';

@Component<DailyMenuK12Layout>({
	components: {
		ExpansionPanel,
		TextMenu
	}
})
export default class DailyMenuK12Layout extends Vue {
	@Prop({ type: Array, required: true }) private menus!: Menu[];
	@Prop({ type: String, required: false, default: 'vertical' }) private cardStyle!: string;

	/**
	 * Generate subtitle for menus and sections
	 *
	 * @param {Menu | MenuSection} menu
	 * @return {string}
	 */
	private getMenuSubtitle(menu: Menu | MenuSection): string {
		if (menu.sections?.length) {
			if (menu.sections.length === 1) {
				const sectionItemCount = menu.sections[0].items.length;
				return this.$tc('menu.item_count', sectionItemCount, { count: sectionItemCount });
			}

			const sectionCount = menu.sections.length;
			return this.$tc('menu.section_count', sectionCount, { count: sectionCount });
		}

		const itemCount = menu.items.length;
		return this.$tc('menu.item_count', itemCount, { count: itemCount });
	}
}
